// extracted by mini-css-extract-plugin
export default {"NoInstrumentsBox":"NoInstrumentsBox_NoInstrumentsBox__yWZCP","TitleInfoBox":"NoInstrumentsBox_TitleInfoBox__empEb","SubtitleInfoBox":"NoInstrumentsBox_SubtitleInfoBox__590L7"};